<button
  (click)="btnClick.emit($event)"
  [disabled]="disabled"
  class="btn bg-red-500 text-white buttons-action-table py-2 px-1"
>
  <fa-icon [icon]="faTrashCan"></fa-icon>
</button>
